var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloudPrivacy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 55.891,
  height: 55.888,
  "data-name": "cloud privacy",
  viewBox: "0 0 55.891 55.888"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c39",
  d: "M51.8 21.83h-3.513a7.374 7.374 0 0 0-6.441-8.69 13.918 13.918 0 0 0-27.793 0 7.374 7.374 0 0 0-6.441 8.69H4.094a4.094 4.094 0 0 0 0 8.187h17.575v2.4h-2.456a.82.82 0 0 0-.819.819v10.918a.82.82 0 0 0 .819.819h17.466a.82.82 0 0 0 .819-.819V33.237a.82.82 0 0 0-.819-.819h-2.456v-2.4H51.8a4.094 4.094 0 1 0 0-8.187ZM35.86 43.335H20.031v-9.279H35.86Zm-3.275-10.916h-9.279v-2.4h9.279Zm0-4.039h-9.279v-3.876a4.64 4.64 0 0 1 9.279 0Zm19.213 0H34.223v-3.876a6.277 6.277 0 0 0-12.554 0v3.875H4.094a2.456 2.456 0 1 1 0-4.912h4.577a.82.82 0 0 0 .772-1.095 5.732 5.732 0 0 1 5.4-7.641.82.82 0 0 0 .819-.819 12.281 12.281 0 1 1 24.562 0 .82.82 0 0 0 .819.819 5.727 5.727 0 0 1 5.567 7.1h-5.565a.819.819 0 1 0 0 1.637H51.8a2.456 2.456 0 1 1 0 4.912Z",
  "data-name": "Path 782"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#011839",
  d: "M36.988 10.837a9.58 9.58 0 0 0-4.249-5.181.821.821 0 0 0-.824 1.419 7.94 7.94 0 0 1 3.523 4.294.819.819 0 0 0 1.55-.528Z",
  "data-name": "Path 783"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#011839",
  d: "M27.399 41.151h1.092a2.456 2.456 0 0 0 0-4.912h-1.092a2.456 2.456 0 0 0 0 4.912m0-3.275h1.092a.819.819 0 0 1 0 1.637h-1.092a.819.819 0 0 1 0-1.637",
  "data-name": "Path 784"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#011839",
  d: "M38.317 21.829h-.546a.819.819 0 0 0 0 1.637h.546a.819.819 0 0 0 0-1.637",
  "data-name": "Path 785"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M47.049 47.701h-5.731v8.187h5.731a.82.82 0 0 0 .819-.819v-6.55a.82.82 0 0 0-.819-.818",
  "data-name": "Path 786"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M8.023 48.52v6.55a.82.82 0 0 0 .819.819h30.839v-8.188H8.842a.82.82 0 0 0-.819.819m24.016 2.456h1.637a.819.819 0 1 1 0 1.637h-1.637a.819.819 0 1 1 0-1.637m-5.458 0h1.642a.819.819 0 1 1 0 1.637h-1.642a.819.819 0 1 1 0-1.637m-5.458 0h1.637a.819.819 0 1 1 0 1.637h-1.637a.819.819 0 1 1 0-1.637m-5.458 0h1.637a.819.819 0 1 1 0 1.637h-1.638a.819.819 0 1 1 0-1.637Z",
  "data-name": "Path 787"
})));
export default SvgCloudPrivacy;